<script setup lang="ts">
interface Props {
	folder?: string
	speed?: number
	pauseOnHover?: boolean
}

interface GalleryItem {
	id?: number | string
	name: string
	url?: string
	source_url?: string
	src?: string
}

const props = withDefaults(defineProps<Props>(), {
	folder: "clients",
	speed: 20,
	pauseOnHover: true
})

const { getGalleryImages } = useWordPress()
const { data: galleryData } = await getGalleryImages(props.folder)

const loopItems = computed(() => {
	if (!galleryData.value) return []

	const items = (galleryData.value as GalleryItem[])
		.map((img) => {
			const rawImg = img as Record<string, any>
			const rawUrl = img.url || img.source_url || img.src || rawImg.full_url || ""

			return {
				// Pass the clean, unencoded raw URL
				url: rawUrl ? String(rawUrl) : "",
				label: img.name ? img.name.replace(/\.[^/.]+$/, "").replace(/[-_]/g, " ") : ""
			}
		})
		.filter((item) => item.url.trim() !== "")

	return [...items, ...items]
})
</script>

<template>
	<div class="text-brand flex items-center bg-white py-16">
		<div class="flex flex-col overflow-hidden px-4 sm:mx-auto sm:grid sm:max-w-5xl sm:grid-cols-2 sm:gap-8">
			<div class="flex items-center justify-start sm:col-span-1">
				<div>
					<p class="mt-2 font-sans text-xs uppercase">Our guests</p>
					<h2 class="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">Companies we’ve welcomed on board</h2>
					<p class="py-4">Some of the companies we’ve had the pleasure of hosting at Floating G.O.A.T.</p>
				</div>
			</div>

			<div class="relative mx-auto flex h-48 w-full max-w-3xl items-center overflow-hidden sm:col-span-1">
				<div class="pointer-events-none absolute inset-y-0 left-0 z-10 w-32 bg-gradient-to-r from-white to-transparent" />
				<div class="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-white to-transparent" />

				<div class="marquee-track animate-marquee flex w-max items-center justify-center gap-12" :class="{ 'pause-on-hover': pauseOnHover }" :style="{ animationDuration: `${speed}s` }">
					<div v-for="(item, index) in loopItems" :key="`${item.url}-${index}`" class="flex shrink-0 flex-col items-center gap-2">
						<NuxtImg v-if="item.url" :src="item.url" :alt="item.label" height="72" format="webp" loading="lazy" decoding="async" class="h-16 max-h-16 w-auto shrink-0 object-cover" />
						<span class="text-brand text-brand/50 text-xs font-semibold whitespace-nowrap">{{ item.label }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
